import { render } from "./PlanosAdmin.vue?vue&type=template&id=14c2e5c4"
import script from "./PlanosAdmin.vue?vue&type=script&lang=js"
export * from "./PlanosAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__